import { useEffect, useMemo, useState } from "react"
import { GAME_FACT_HANDBALL_SHOOTOUT, GAME_FACT_SHOOTOUTPENALTY, GAME_FACT_SOCCER_SHOOTOUTPENALTY } from "../gamefacts/constants.js"
import { scoreResolver } from "../gamefacts/scoreutils.js"

export function useScoreResolver(match){

    const [homeScore, setHomeScore] = useState(0)
    const [awayScore, setAwayScore] = useState(0)

    const [homeScorers, setHomeScorers] = useState([])
    const [awayScorers, setAwayScorers] = useState([])

    const [homeShoutoutSucceed, awayShoutoutSucceed] = useMemo(() => {
        if(!match.gameFacts || !match.gameFacts.length)
            return [0, 0]

        // On conserve uniquement les tirs au but
        let shoutoutGameFacts = match.gameFacts.filter(g => [GAME_FACT_SHOOTOUTPENALTY, GAME_FACT_SOCCER_SHOOTOUTPENALTY, GAME_FACT_HANDBALL_SHOOTOUT].includes(g.type))

        const homeTeamId = match.homeTeam._id;
        const awayTeamId = match.awayTeam._id;

        const homeShoutout = shoutoutGameFacts.filter(g => g.detail.team === homeTeamId && (g.detail.butSucced || g.detail.penalitySucced)).length
        const awayShoutout = shoutoutGameFacts.filter(g => g.detail.team === awayTeamId && (g.detail.butSucced || g.detail.penalitySucced)).length

        return [homeShoutout, awayShoutout]
    }, [match])


    useEffect(() => {
        if(!match.gameFacts || !match.homeTeam)
            return

        const [homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul, awayPlayerScoreCalcul] = scoreResolver(match)

        setHomeScore(homeScoreCalcul)
        setAwayScore(awayScoreCalcul)

        setHomeScorers(homePlayerScoreCalcul)
        setAwayScorers(awayPlayerScoreCalcul)

    }, [match, match.gameFacts])

    return [homeScore, awayScore, homeScorers, awayScorers, homeShoutoutSucceed, awayShoutoutSucceed]
}